import { NewRunHeader } from '@components/OrderDispatch/OptimizerWizard/Create/NewRunHeader'
import { OrderGrid } from '@components/OrderDispatch/OptimizerWizard/Create/OrderGrid'
import { ScheduleGrid } from '@components/OrderDispatch/OptimizerWizard/Create/ScheduleGrid'
import { Horizontal } from '@gravitate-js/excalibrr'
import type { CreateNewRunProps } from '../types'

export function CreateNewRun({
  startOptimizerRun,
  depots,
  handleOrderSelectionChanged,
  loading,
  orderData,
  scheduleData,
  selectedRun,
  resetOptimizer,
}: CreateNewRunProps) {
  return (
    <>
      <NewRunHeader
        startOptimizerRun={startOptimizerRun}
        loading={loading}
        selectedRun={selectedRun}
        resetOptimizer={resetOptimizer}
      />
      <Horizontal flex={1}>
        <OrderGrid
          selectedRun={selectedRun}
          orderData={orderData}
          handleOrderSelectionChanged={handleOrderSelectionChanged}
          loading={!!loading}
        />
      </Horizontal>
      <Horizontal flex={1}>
        <ScheduleGrid scheduleData={scheduleData} depots={depots} selectedRun={selectedRun} loading={loading} />
      </Horizontal>
    </>
  )
}
